"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class RelationshipTypeApi extends runtime.BaseAPI {
    /**
     */
    apiRelationshipTypeDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/RelationshipType`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiRelationshipTypeDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiRelationshipTypeDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiRelationshipTypeListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/RelationshipType/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IRelationshipTypeIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiRelationshipTypeListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipTypeListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiRelationshipTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/RelationshipType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RelationshipTypeConstructToJSON(requestParameters.relationshipTypeConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IRelationshipTypeIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiRelationshipTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipTypePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiRelationshipTypeRestorePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/RelationshipType/Restore`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiRelationshipTypeRestorePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiRelationshipTypeRestorePostRaw(requestParameters);
        });
    }
}
exports.RelationshipTypeApi = RelationshipTypeApi;
